export default function ConfigStore(vm) {
    this.create = function(params) {
        var url = '/config/user/create';

        return vm.post(url, params);
    };

    this.get = function() {
        var url = '/config/user/detail';

        return vm.get(url);
    };
}